var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 26,
    viewBox: "0 0 109 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7344 1.47928C88.2551 1.95856 88.2551 2.72995 88.2551 4.27273V14.5831C88.2551 15.3224 88.2551 15.6921 88.4044 16.0172C88.5536 16.3423 88.834 16.5832 89.3947 17.0651L96.4944 23.1668C97.5121 24.0414 98.021 24.4787 98.6275 24.4787C99.2341 24.4787 99.743 24.0414 100.761 23.1668L107.86 17.0651L107.86 17.0651C108.421 16.5832 108.701 16.3423 108.851 16.0172C109 15.6921 109 15.3224 109 14.5831V4.27273C109 2.72995 109 1.95856 108.521 1.47928C108.041 1 107.27 1 105.727 1H91.5278C89.985 1 89.2137 1 88.7344 1.47928ZM103.517 11.3345L98.6275 6.48572L93.7379 11.3345L98.6275 16.1832L103.517 11.3345Z",
    fill: "#D6D6D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109 16.0857L100.761 23.1668C99.743 24.0414 99.2341 24.4787 98.6275 24.4787C98.021 24.4787 97.5121 24.0414 96.4944 23.1668L88.2826 16.1094L88.2551 16.1337V16.0857L88.2826 16.1094L93.7387 11.2857L98.6275 16.1817L103.516 11.2857L109 5.848V16.0857Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.871 10.9499L73.1002 8.44004C73.8174 7.63254 75.0658 7.59355 75.832 8.35472L80.6512 13.1421C81.8421 14.3252 81.0043 16.3574 79.3256 16.3574H67.5139C63.8782 16.3574 60.9308 13.41 60.9308 9.77431V2.95612",
    stroke: "#D6D6D6",
    strokeWidth: 3.81818
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.024 24.116V22.2351H78.9174V24.116H77.024Z",
    stroke: "white",
    strokeWidth: 1.88088
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9968 6.24765V4.36677H48.6236V6.24765H41.9968Z",
    stroke: "white",
    strokeWidth: 1.88088
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9572 24.116V22.2351H31.584V24.116H24.9572Z",
    stroke: "white",
    strokeWidth: 1.88088
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0672 9.06898V10.0094C54.0672 13.6451 51.1199 16.5925 47.4842 16.5925H19.0401M19.0401 16.5925V3.19123M19.0401 16.5925H8.58301C4.94728 16.5925 1.99994 13.6451 1.99994 10.0094V9.5392",
    stroke: "#D6D6D6",
    strokeWidth: 3.81818
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20175 1.54546L7.94711 2.87312C7.62378 3.21527 7.44363 3.66818 7.44363 4.13893V4.13893C7.44363 5.15676 8.26875 5.98188 9.28659 5.98188H10.5541M10.5541 5.98188L12.177 4.26456M10.5541 5.98188L8.52555 8.12853",
    stroke: "#D6D6D6",
    strokeWidth: 2.3511
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMenu);
export default __webpack_public_path__ + "static/media/logo-menu.49659d32ef0f73212e453290e9c382d5.svg";
export { ForwardRef as ReactComponent };